/* eslint-disable react/jsx-no-useless-fragment */
import _, { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Popup, Grid, Dropdown, Icon, Label } from "../..";
import TableRichCell from "./TableRichCell";
import "./TableRich.css";
import TableRichPopupFilter from "./TableRichPopupFilter";

/**
 * Table Rich
 */
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TableRich = function TableRich(props) {
  var columns = props.columns,
    items = props.items,
    onSave = props.onSave,
    onFilterChangeProp = props.onFilterChange,
    mountNode = props.mountNode,
    label = props.label,
    lineReduced = props.lineReduced,
    tableRichHeight = props.height,
    tableRichWidth = props.width,
    onCreate = props.onCreate,
    addWithModalAssistant = props.addWithModalAssistant;
  var _useState = useState([]),
    filters = _useState[0],
    setFilters = _useState[1];
  var _useState2 = useState([]),
    filtersAfterClose = _useState2[0],
    setFiltersAfterClose = _useState2[1];
  var _useState3 = useState([]),
    itemsFilter = _useState3[0],
    setItemsFilter = _useState3[1];
  var _useState4 = useState([]),
    filtersOptions = _useState4[0],
    setFiltersOptions = _useState4[1];
  var _useState5 = useState([]),
    filtersDisplay = _useState5[0],
    setFiltersDisplay = _useState5[1];

  // permet de laisser l'icone filtre affiché tant que la popup est ouverte (avec css)
  var _useState6 = useState(''),
    cellKeyFilterOpen = _useState6[0],
    setCellKeyFilterOpen = _useState6[1];
  useEffect(function () {
    var filterDisplayTemp = [];
    var filterOptionsTemp = [];
    filtersAfterClose.map(function (filter) {
      if (!_.isEmpty(filter.filterValues)) {
        filter.filterValues.map(function (value) {
          filterDisplayTemp.push("" + value);
          filterOptionsTemp.push({
            key: filter.label + " = " + value,
            value: "" + value,
            text: filter.label + " = " + value
          });
          return true;
        });
      }
      return true;
    });
    setFiltersDisplay(filterDisplayTemp);
    setFiltersOptions(filterOptionsTemp);
    if (onFilterChangeProp) {
      onFilterChangeProp(filtersAfterClose);
    }
  }, [filtersAfterClose, onFilterChangeProp]);

  // on veut que le useEffect s'execute lors du component did mount
  // donc le tableau de dépendance doit etre vide
  // NE PAS METTRE column DANS LE TABLEAU DE DEPENDANCES
  useEffect(function () {
    // initialisation du tableau de filtre
    var filtersTmp = [];
    columns.map(function (col) {
      if (col.withFilter) {
        filtersTmp.push({
          column: col.item,
          label: col.label,
          filterValues: []
        });
      }
      return true;
    });
    setFilters(filtersTmp);
  }, []);
  var handleFilterChange = function handleFilterChange(col, newFilter) {
    var filtersTmp = _.cloneDeep(filters);
    filtersTmp.map(function (filter) {
      if (filter.column === col) {
        _.set(filter, 'filterValues', newFilter);
      }
      return true;
    });
    setFilters(filtersTmp);
  };
  var handleCloseFilter = function handleCloseFilter() {
    // if (onFilterChangeProp) {
    //     onFilterChangeProp(filters);
    // }
    setCellKeyFilterOpen('');
    setFiltersAfterClose(filters);
  };
  var handleChangeFilterBar = function handleChangeFilterBar(event, data) {
    // on a supprimé un filtre par la barre de filtre du haut
    var _ref = data || {},
      value = _ref.value;
    var filtersClone = _.cloneDeep(filters);
    filtersClone.map(function (filter) {
      return _.set(filter, 'filterValues', _.filter(filter.filterValues, function (f) {
        return _.indexOf(value, f) !== -1;
      }));
    });
    setFilters(filtersClone);
    setFiltersAfterClose(filtersClone);
  };
  var itemReducer = function itemReducer(state, action) {
    switch (action.type) {
      case 'CHANGE_SORT':
        if (state.column === action.column && state.direction === 'ascending') {
          return Object.assign({}, state, {
            data: state.data.slice().reverse(),
            direction: 'descending'
          });
        }
        if (state.column === action.column && state.direction === 'descending') {
          return {
            column: null,
            data: itemsFilter,
            direction: null
          };
        }
        return {
          column: action.column,
          data: _.sortBy(state.data, [action.column]),
          direction: 'ascending'
        };
      case 'CHANGE_FILTER':
        // eslint-disable-next-line no-case-declarations
        var itemsFilterTemp = [];
        // filtrer les items suivant les filtres choisi
        if (!_.isNil(action.listeItems)) {
          action.listeItems.map(function (item) {
            // l'item vérifie les filtre
            var itemVerifyFilter = true;
            // on parcourt tous les champs de l'item pour vérifier les filtre sur chacun d'eux
            _.map(item, function (value, key) {
              // on récupère la liste des valeurs filtré sur cette colonne
              var filterColumn = _.find(filtersAfterClose, function (filter) {
                return filter.column === key;
              });
              if (!_.isNil(filterColumn) && !_.isEmpty(filterColumn.filterValues)) {
                // si on a des valeurs de filtre et que la valeur de l'item courant n'est pas dedans
                if (_.findIndex(filterColumn.filterValues, function (val) {
                  return val === value;
                }) === -1) {
                  // on exclut l'item
                  itemVerifyFilter = false;
                }
              }
              return true;
            });
            itemsFilterTemp.push(Object.assign({}, item, {
              inFilterResult: itemVerifyFilter
            }));
            return true;
          });
        }
        setItemsFilter(itemsFilterTemp);
        return Object.assign({}, state, {
          data: itemsFilterTemp
        });
      default:
        throw new Error();
    }
  };
  var _React$useReducer = React.useReducer(itemReducer, {
      column: null,
      data: items,
      direction: null
    }),
    state = _React$useReducer[0],
    dispatch = _React$useReducer[1];
  var column = state.column,
    data = state.data,
    direction = state.direction;
  useEffect(function () {
    dispatch({
      type: 'CHANGE_FILTER',
      listeItems: items
    });
  }, [filtersAfterClose, items]);
  var ref = React.useRef(null);
  var _useState7 = useState(false),
    newLine = _useState7[0],
    setNewLine = _useState7[1];
  var handleCreate = function handleCreate() {
    if (_.isNil(addWithModalAssistant) || addWithModalAssistant === false) {
      onCreate();
      setNewLine(true);
    } else {
      onCreate();
    }
  };
  useEffect(function () {
    // si nouvelle ligne ajoutée alors scroll en bas du tableau
    if (newLine) {
      var _ref$current;
      (_ref$current = ref.current) == null || _ref$current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [data.length, newLine]);
  return /*#__PURE__*/_jsxs(Grid, {
    style: !_.isNil(tableRichWidth) ? {
      width: tableRichWidth,
      paddingTop: 0
    } : {
      paddingTop: 0
    },
    children: [(_.isNil(filters) || isEmpty(filters)) && (_.isNil(label) || isEmpty(label)) && _.isNull(onCreate) ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsxs(Grid.Row, {
      style: {
        paddingBottom: 0
      },
      children: [/*#__PURE__*/_jsxs(Grid.Column, {
        width: 12,
        verticalAlign: "bottom",
        children: [_.isNil(filters) || isEmpty(filters) ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Dropdown, {
            placeholder: "Aucun filtre appliqu\xE9",
            name: "filtre",
            multiple: true,
            selection: true,
            className: "ListeFiltre",
            options: filtersOptions,
            onChange: handleChangeFilterBar,
            value: filtersDisplay
          }, "filtre"), /*#__PURE__*/_jsx("br", {})]
        }), _.isNil(label) || isEmpty(label) ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(Label, {
          className: "titreTableRich",
          children: label
        })]
      }), !_.isNull(onCreate) ? /*#__PURE__*/_jsx(Grid.Column, {
        style: {
          paddingBottom: 5
        },
        verticalAlign: "bottom",
        textAlign: "right",
        width: 4,
        children: /*#__PURE__*/_jsxs(Button, {
          icon: true,
          basic: true,
          onClick: handleCreate,
          children: [/*#__PURE__*/_jsx(Icon, {
            name: "add"
          }), "Ajouter"]
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    }), /*#__PURE__*/_jsx(Grid.Row, {
      style: {
        paddingTop: 0
      },
      children: /*#__PURE__*/_jsx(Grid.Column, {
        children: /*#__PURE__*/_jsxs(Table, {
          onScroll: function onScroll() {
            return setNewLine(false);
          },
          singleLine: true,
          selectable: true,
          className: lineReduced ? 'tableTRreduced' : 'tableTR',
          collapsing: true,
          children: [/*#__PURE__*/_jsx(Table.Header, {
            className: "thTableRich",
            children: /*#__PURE__*/_jsx(Table.Row, {
              children: !_.isNil(columns) && !_.isEmpty(columns) ? columns.map(function (col, i) {
                var headCellKeyTmp = "headcell_" + i;
                var filtersCol = _.find(filters, function (filter) {
                  return filter.column === col.item;
                });
                return /*#__PURE__*/_jsxs(Table.HeaderCell, {
                  width: col.width,
                  textAlign: col.columnAlign,
                  sorted: column === col.item ? direction : null,
                  children: [col.label, col.withFilter ? /*#__PURE__*/_jsx(Popup, {
                    on: "click",
                    mountNode: mountNode,
                    className: "popupFiltre",
                    content: /*#__PURE__*/_jsx(TableRichPopupFilter, {
                      items: items,
                      filters: filtersCol,
                      onFilterChange: handleFilterChange
                    }),
                    pinned: true,
                    position: "bottom center",
                    size: "large",
                    hoverable: true,
                    onClose: function onClose() {
                      return handleCloseFilter();
                    },
                    trigger: /*#__PURE__*/_jsx(Button, {
                      className: (_.isNil(filtersCol) || _.isEmpty(filtersCol.filterValues) ? 'iconFilter' : 'iconFilterYellow') + " \n                                  " + (cellKeyFilterOpen === headCellKeyTmp ? 'iconFilterOpen' : 'iconFilterClose'),
                      inline: true,
                      icon: "filter",
                      size: "small",
                      onClick: function onClick() {
                        return setCellKeyFilterOpen(headCellKeyTmp);
                      },
                      style: {
                        color: _.isNil(filtersCol) || _.isEmpty(filtersCol.filterValues) ? 'gray' : '#ffaa00'
                      }
                    })
                  }) : /*#__PURE__*/_jsx(_Fragment, {}),
                  // eslint-disable-next-line no-nested-ternary
                  col.withSort && (_.isNil(direction) || direction === 'ascending') ? /*#__PURE__*/_jsx(Button, {
                    className: "" + (_.isNil(direction) ? 'iconSortUp' : 'iconSortUpYellow'),
                    icon: "arrow up",
                    size: "small",
                    onClick: function onClick() {
                      return dispatch({
                        type: 'CHANGE_SORT',
                        column: col.item
                      });
                    },
                    style: {
                      color: _.isNil(direction) ? 'gray' : '#ffaa00'
                    }
                  }) : col.withSort && direction === 'descending' ? /*#__PURE__*/_jsx(Button, {
                    className: "iconSortDownYellow",
                    icon: "arrow down",
                    size: "small",
                    onClick: function onClick() {
                      return dispatch({
                        type: 'CHANGE_SORT',
                        column: col.item
                      });
                    },
                    style: {
                      color: '#ffaa00'
                    }
                  }) : /*#__PURE__*/_jsx(_Fragment, {})]
                }, headCellKeyTmp);
              }) : null
            })
          }), /*#__PURE__*/_jsxs(Table.Body, {
            className: "tableTrBody",
            style: !_.isNil(tableRichHeight) ? {
              height: tableRichHeight
            } : {},
            children: [data && data.map(function (item, iItem) {
              var rowKeyTmp = "row_" + iItem;
              return item.inFilterResult ? /*#__PURE__*/_jsx(Table.Row, {
                disabled: item.props && item.props.disabled,
                error: item.props && item.props.error,
                warning: item.props && item.props.warning,
                positive: item.props && item.props.positive,
                negative: item.props && item.props.negative,
                className: item.props && item.props.disabled ? 'trTableRichDisabled' : 'trTableRich',
                children: /*#__PURE__*/_jsx(TableRichCell, {
                  cellKey: rowKeyTmp,
                  columns: columns,
                  item: item,
                  onSave: onSave,
                  mountNode: mountNode
                })
              }, rowKeyTmp) : /*#__PURE__*/_jsx(_Fragment, {});
            }), /*#__PURE__*/_jsx("div", {
              ref: ref
            })]
          })]
        })
      })
    })]
  });
};
TableRich.handledProps = ["addWithModalAssistant", "columns", "height", "items", "label", "lineReduced", "mountNode", "onCreate", "onFilterChange", "onSave", "width"];
TableRich.propTypes = {
  onSave: PropTypes.func,
  onFilterChange: PropTypes.func,
  mountNode: PropTypes.node,
  height: PropTypes.number,
  lineReduced: PropTypes.bool,
  label: PropTypes.string,
  columns: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])),
  items: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])),
  width: PropTypes.number,
  onCreate: PropTypes.func,
  addWithModalAssistant: PropTypes.bool
};
TableRich.defaultProps = {
  onSave: null,
  height: null,
  label: '',
  // mountNode: null,
  onFilterChange: null,
  columns: [],
  items: [],
  lineReduced: false,
  width: null,
  onCreate: null,
  addWithModalAssistant: false
};
export default TableRich;